import React from 'react';
import { useCampfireTheme } from '../../../theme/useCampfireTheme';

const MobilePublicAppBar = React.lazy(() => import('./MobilePublicAppBar'));
const DesktopPublicAppBar = React.lazy(() => import('./DesktopPublicAppBar'));

const PublicAppBar = ({ logoOnly }: { logoOnly?: boolean }) => {
  const { isMobile } = useCampfireTheme();

  if (isMobile && logoOnly) return null;
  if (isMobile) return <MobilePublicAppBar />;
  return <DesktopPublicAppBar logoOnly={logoOnly} />;
};

export { PublicAppBar };
